import { useState, useRef, useEffect } from 'react';
import { KeyHint } from '@/components/KeyHint';
import { ColumnEditConfig } from '@/types/table';

interface CellEditorProps {
    value: string;
    onCommit: (value: string) => void;
    onCancel: () => void;
    editConfig?: ColumnEditConfig;
}

export function CellEditor({
    value,
    onCommit,
    onCancel,
    editConfig,
}: CellEditorProps) {
    const initialValue = editConfig?.initialValue ?? value;
    const [localValue, setLocalValue] = useState(initialValue);
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        const input = inputRef.current;
        if (input) {
            input.focus();
            input.setSelectionRange(input.value.length, input.value.length);
        }
    }, []);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onCommit(localValue);
        } else if (e.key === 'Escape') {
            e.preventDefault();
            onCancel();
        }
    };

    const handleBlur = () => {
        onCommit(localValue);
    };

    return (
        <div className="relative flex items-center">
            <input
                ref={inputRef}
                type="text"
                value={localValue}
                onChange={(e) => setLocalValue(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
                className="w-full bg-transparent border-none outline-none text-sm text-white-100"
            />
            <KeyHint theme="dark" className="flex-shrink-0 ml-2">
                ↵
            </KeyHint>
        </div>
    );
}
